<template>
  <Widget
    :title="title"
    :tooltip="tooltip"
    title-type="bold"
    :content-overflow="true"
    :action-handler="actionHandler"
    :loading="loading"
  >
    <div class="widget-body" v-if="data && data.length">
      <div v-if="coords.length" class="map-container">
        <Map
          :center="center"
          :coords="coords"
          :bounds="coords"
          default-class="map-widget"
        >
          <template v-slot:marker v-if="coords.length">
            <MapMarker
              v-for="(coord, index) in coords"
              :key="coord.toString()"
              :icon="coord"
              :marker-type="markerType"
              :number="index + 1"
              icon-number-class="map-widget-marker"
            />
          </template>
        </Map>
      </div>
      <FacilitiesList :items="data">
        <template v-slot="item">
          <slot v-bind="item"></slot>
        </template>
      </FacilitiesList>
    </div>
    <NoData v-else />
  </Widget>
</template>

<script>
import Widget from "@/components/Dashboard/base/Widget";
import Map from "@/components/ui/Map/MapWithBounds";
import MapMarker from "@/components/ui/Map/Marker.vue";
import { numberedPrimary } from "@/config/marker";
import cuid from "cuid";
import FacilitiesList from "@/components/Dashboard/base/FacilitiesList";
import NoData from "@/components/ui/NoData";
import { dashboardWidget } from "@/helpers/mixins/dashboard-widget";

export default {
  name: "DashboardMapWidget",
  components: {
    Widget,
    Map,
    MapMarker,
    FacilitiesList,
    NoData
  },
  mixins: [dashboardWidget],
  props: {
    title: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
    markerType: {
      type: Object,
      default: () => numberedPrimary
    }
  },
  computed: {
    coords() {
      return this.data
        .filter(({ geo }) => geo)
        .map(({ geo }) => [geo.latitude, geo.longitude]);
    },
    center() {
      return { icon: [52.2200567, 19.2701527], id: cuid() };
    }
  }
};
</script>

<style lang="scss" scoped>
.widget-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  &:not(:has(.map-container)) {
    display: block;
    ::v-deep .facilities-list {
      margin: 0;
      max-width: 100%;
    }
  }

  .map-container {
    display: flex;
    flex: 1;
    height: 100%;
    width: 100%;
    min-width: 0;
    position: relative;
  }

  .map-widget {
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 25px;
  }
}
</style>
